/**
 * Shared password strength policy for registration and password updates.
 * Passwords are never trimmed — whitespace anywhere is rejected.
 */
export const PASSWORD_MIN_LENGTH = 8;

/**
 * @param {string} password
 * @returns {string|null} User-facing error message, or null if valid
 */
export function validatePassword(password) {
  if (password == null || typeof password !== 'string' || password.length === 0) {
    return 'Password is required.';
  }
  if (/\s/.test(password)) {
    return 'Password must not contain spaces.';
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    return 'Password must be at least 8 characters long.';
  }
  if (!/[A-Z]/.test(password)) {
    return 'Password must contain at least one uppercase letter.';
  }
  if (!/[a-z]/.test(password)) {
    return 'Password must contain at least one lowercase letter.';
  }
  if (!/\d/.test(password)) {
    return 'Password must contain at least one number.';
  }
  if (!/[^A-Za-z0-9]/.test(password)) {
    return 'Password must contain at least one special character.';
  }
  return null;
}

/**
 * Trim leading/trailing whitespace for non-password text fields.
 * @param {string} value
 * @returns {string}
 */
export function trimText(value) {
  return typeof value === 'string' ? value.trim() : value;
}
